import { fgWmsFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import PackageCheckIcon from "@redotech/redo-icons/package-check.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-views-common/advanced-filters/array-string-filter";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgWmsFilterEntries.pickability;

export const pickabilityFilterName = entry.name;

export const PickabilityFilter = (): ArrayStringTableFilter<string> => ({
  type: entry.type,
  Icon: PackageCheckIcon,
  operators: entry.operators,
  data: {
    name: pickabilityFilterName,
    type: entry.type,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  itemLabel: "pickability",
  itemLabelPlural: "pickability statuses",
  display: (item: string) => {
    switch (item) {
      case "all_pickable":
        return "All pickable";
      case "partially_pickable":
        return "Partially pickable";
      case "not_pickable":
        return "Not pickable";
      case "all_pending_wo":
        return "Pending work orders";
      case "partially_pending_wo":
        return "Partially pending WO";
      case "picking":
        return "Picking";
      default:
        return item;
    }
  },
  displayName: entry.displayName,
  values: entry.staticValues,
});
